import Table from "./table.component";

export { Table };

export default Table;